module.exports = __webpack_public_path__ + "img/big-white-arrow.5d207928.svg";